<template>
    <div>
        <bc-list
            v-if="(items || []).length > 0"
            :perm="perm"
            :items="items"
            prepend-position="top"
            prepend-icon="comment"
            @invoke-method="$refs.noteDialog.showNote($event)"
        >
            <template slot-scope="data">
                <v-container py-3 pr-3 pl-1>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <div>
                                <v-flex list-sub black--text>{{ data.item.created_by }}</v-flex>
                                <v-flex list-sub style="font-size: 12px !important;"> {{ data.item.date_created }}</v-flex>
                            </div>
                            <div style="white-space: pre-line;">{{ data.item.note | shrink_text(250) }}</div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </template>
        </bc-list>
        <v-layout row class="my-0 pt-2" v-if="hasPerm(perm) && hasScope('create')">
            <v-flex xs2 pt-0 style="max-width: 40px">
                <v-icon class="mt-3 mb-auto" color="indigo">mode_comment</v-icon>
            </v-flex>
            <v-flex class="xs10 px-0 pt-2 pb-0">
                <v-form ref="entity_note" style="margin: 0px -4px;">
                    <v-textarea
                        v-model="entity_note.note"
                        :placeholder="$t('lang.add_note')"
                        auto-grow
                        single-line
                        rows="1"
                        :rules="ifValid('entity_note.note')"
                        hide-details
                        full-width
                        outline
                        style="left: 5px; bottom: 8px; max-width: 95%;"
                        :key="growText"
                        @keydown.enter.exact.prevent="entity_note.note ? modifyEntityNote('post') : null"
                    >
                        <template slot="append">
                            <bc-tooltip top>
                                <template slot="activator">
                                    <v-btn
                                        v-if="!!entity_note.note"
                                        icon
                                        @mouseup.left="modifyEntityNote('post')"
                                        style="top:-20px;"
                                    >
                                        <v-icon class="material-icons-outlined">add</v-icon>
                                    </v-btn>
                                </template>
                                {{ $t('lang.add') }}
                            </bc-tooltip>
                        </template>
                    </v-textarea>
                </v-form>
            </v-flex>
        </v-layout>

        <bc-notes-dialog
            ref="noteDialog"
            :entity-object="entityObject"
            :api-url="apiUrl"
            :scope="scope"
            :state-property="stateProperty"
        ></bc-notes-dialog>
    </div>
</template>

<script>

import { mapState } from "vuex";
import _ from 'lodash'

export default {
    props: {
        entityObject: { // object name matching store
            type: String,
            required: true
        },
        scope: { // scope from parent
            type: String,
            default: null
        },
        apiUrl: { // url that `/notes/${notes_id}` appends to for modifying note
            type: String,
            required: true
        },
        stateProperty: {
            type: String,
            required: true
        },
        items: {
            type: Array,
            required: true
        },
        perm: {
            type: [String, Boolean],
            default: true
        }
    },
    data() {
        return {
            entity_note: {
                note: "",
            },
            current_obj: null,
            entity_note_dialog: false,
            growText: 0,
        };
    },
    computed: {
        ...mapState({
            rules_entity_note: state => state.validation.rules_entity_note
        }),
        fetchObject(){ // use entity_object to create store action
            return `fetch${_.upperFirst(_.camelCase(this.entityObject))}`;
        },
        currObjField(){
            return field => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : ''
            }
        },
        hasScope(){
            return scope => {
                return !this.scope || this.scope.includes(`${scope}`) || !this.currObjField('note_id');
            }
        }
    },
    methods: {
        close() {
            this.entity_note_dialog = false;
            if(this.$refs.delete_entity_note) this.$refs.delete_entity_note.close();
            this.$store.commit('toggleModalLoader', false);
        },
        modifyEntityNote(method = null, id = null) {
            if(method && this.entity_note.note){
                this.$nextTick(() => {
                    this.$store.commit('toggleModalLoader', true);
                    this.$store.dispatch(
                        this.fetchObject,
                        {
                            pk: 'note_id',
                            id: id,
                            url: `${this.apiUrl}/notes/${id ? id : ''}`,
                            method: method,
                            stateProperty: this.stateProperty,
                            dataProperty: 'notes',
                            mutate: true,
                            body: method != 'delete' ? this.entity_note : null
                        }
                    ).then((data) => {
                        if(data && data.code == '200'){
                            this.close();
                            this.entity_note.note = "";
                            this.growText++;
                        }else{
                            this.$store.commit('toggleModalLoader', false);
                        }
                    })
                });
            }
        },
        showNote(item = null) {
            this.current_obj = item;

            if(this.$refs.entity_note) item ? this.$refs.entity_note.resetValidation() : this.$refs.entity_note.reset();

            this.$nextTick(() => {
                this.assignObj(this.entity_note, item, this.rules_entity_note);
                this.entity_note_dialog = true;
                this.growText++;
            })
        },
    }
};
</script>